import type CtrlGrp from "../entity/ctrl-grp";

class GroupBox {
  public color = "#cfcfcf";
  public isSelect = false;
  constructor(readonly x: number, readonly y: number, readonly width: number, readonly height: number, readonly group: CtrlGrp) {
  }
}

export default GroupBox;